import React, {useEffect, useRef, useState} from "react";
import SVG from 'react-inlinesvg';

import {
    ReactSketchCanvas
} from 'react-sketch-canvas';


import {
    Row, Col
} from "react-bootstrap";


import {
    ButtonComponent
} from "@Components/Forms";


import IconArrowLeftSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-arrow_left-sm-brown.svg";
import IconArrowRightSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-arrow_right-sm-brown.svg";
import IconPenSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-pen-sm-brown.svg";
import IconRadioCheckedSmOrange from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-radio_checked-sm-orange.svg";
import IconRadioUnCheckedSmGrey from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-radio_unchecked-sm-grey.svg";

import IconUndoSmBrown from "./@Icons/icon-undo-sm-brown.svg";
import IconClearSmBrown from "./@Icons/icon-clear-sm-brown.svg";
import IconCheckSmBrown from "./@Icons/icon-check-sm-brown.svg";

import {RefundOptionsCategoriesObject, UserSubmitRequestDataInterface} from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest";
import {BlackoutComponent, CheckboxFieldComponent, DefaultLoaderComponent, DefaultPopupComponent} from "@Elements";
import {SvgIconComponent} from "@Components/Elements";

import "./index.scss";
import InlineSVG from "react-inlinesvg";
import IconAttachFileSmBlack
    from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-attach_file-sm-black.svg";

interface UserDashboardSubmitRequestStep4ComponentProps {
    userSubmitRequestStepSetter: (step: number) => void;
    userSubmitRequestData: UserSubmitRequestDataInterface;
    userSubmitRequestDataSetter: (userSubmitRequestData: UserSubmitRequestDataInterface) => void;
}


export const UserDashboardSubmitRequestStep4Component:React.FC<UserDashboardSubmitRequestStep4ComponentProps> = ({
    userSubmitRequestStepSetter,
    userSubmitRequestData, userSubmitRequestDataSetter
}) => {


    const [redirectLoaderStatus, setRedirectLoaderStatus] = React.useState(false);

    useEffect(() => {
        return () => {
            setRedirectLoaderStatus(false);
        };
    }, []);

    const redirectToDocusignRequestHandler = () => {

        if (selectedUserSignatureType === 1) {
            return setShowDigitalSignaturePopup(true);
        }

        if (selectedUserSignatureType === 2) {
            setRedirectLoaderStatus(true);
            return setTimeout(() => {
                setRedirectLoaderStatus(false);
                userSubmitRequestStepSetter(5);
            }, 3000);
        }

    };

    const [selectedUserSignatureType, setSelectedUserSignatureType] = useState(0);

    useEffect(() => {
        return () => {
            setSelectedUserSignatureType(0);
        };
    }, []);


    const {
        refundOptionsStep: storedRefundOptions,
        personalDataStep: userPersonalData,
        attachedDocumentsStep: {
            documentsList,
        },
    } = userSubmitRequestData;


    const {
        userFirstName, userLastName,
        userAddressStreet, userAddressHouseNo,
        userAddressPostCode, userAddressCityOrTown
    } = userPersonalData;


    const checkedRefundOptions = new Set<number>(storedRefundOptions);

    const refundOptionsCategoriesList = RefundOptionsCategoriesObject.map((refundCategory) => {

        const {
            refundOptionsCategoryId,
            refundOptionsCategoryOptions,
        } = refundCategory;

        const refundOptionsList = Object.entries(refundOptionsCategoryOptions).map(([refundOptionId, refundOptionName]) => {
            if (!checkedRefundOptions.has(+refundOptionId)) {
                return null;
            }
            return (
                <CheckboxFieldComponent
                    key={refundOptionId}
                    checkboxLabel={refundOptionName}
                    checkboxCheckedStatus={true}
                    checkboxDisabledStatus={true}
                />
            );
        }).filter((refundOptionId) => !!refundOptionId);

        if (!refundOptionsList.length) {
            return null;
        }

        return (
            <Col key={refundOptionsCategoryId} xs={12} className={'user-dashboard-submit-request-step__step-section__section-form__form-sub-section'}>
                <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-sub-section__sub-section-content'}>
                    {refundOptionsList}
                </Row>
            </Col>
        );

    });


    const uploadedDocumentsList = documentsList.map((uploadedDocument, i) => {
        return (
            <Col key={`index-${i}`} xs={12} className={'user-uploaded-document'}>
                <SvgIconComponent iconSource={IconAttachFileSmBlack} />
                <span>{uploadedDocument.userDocumentName}</span>
            </Col>
        );
    });


    const styles = {
        margin: 0,
        padding: 0,
        border: 'none',
        backgroundColor: '#FFF'
    };


    const Canvas = () => {
        return (
            <ReactSketchCanvas
                style={styles}
                width="100%"
                height="500"
                strokeWidth={1}
                strokeColor="#000"
                ref={canvasRef}
            />
        );
    };


    const canvasRef = useRef(null);

    const saveHandler = async () => {
        if (!canvasRef?.current) return;
        // @ts-ignore
        const svgObject = await canvasRef.current.exportSvg();
        userSubmitRequestData.signatureStep.signatureType = 'DIGITAL';
        userSubmitRequestData.signatureStep.signatureSrc = svgObject;
        userSubmitRequestDataSetter(
            { ...userSubmitRequestData }
        );
    };

    const clearHandler = () => {
        if (canvasRef?.current) {
            // @ts-ignore
            canvasRef.current.clearCanvas();
        }
    };


    const [showDigitalSignaturePopup, setShowDigitalSignaturePopup] = useState(false);

    useEffect(() => {
        setShowDigitalSignaturePopup(false);
    }, []);


    const digitalSignatureSubmitHandler = async () => {
        await saveHandler();
        setShowDigitalSignaturePopup(false);
        userSubmitRequestStepSetter(5);
    };


    return (
        <Col xs={12} className={'user-dashboard-submit-request-step'}>
            <Row className={'user-dashboard-submit-request-step__step-content'}>

                {redirectLoaderStatus &&
                <DefaultLoaderComponent
                    defaultLoaderText={'Redirecting to Docusign service ...'}
                />
                }

                {showDigitalSignaturePopup &&
                <DefaultPopupComponent
                    popupCloseCallback={() => setShowDigitalSignaturePopup(false)}
                >
                    <Col xs={12} className={'user-signature-popup__popup-header'}>
                        <span>Sign documents</span>
                    </Col>
                    <Col xs={12} className={'user-signature-popup__popup-description'}>
                        <span>Sign in the white field using your mouse cursor, then click Sign documents to confirm your signature.</span>
                    </Col>
                    <Col xs={12} className={'user-signature-popup__popup-buttons'}>
                        <Row className={'user-signature-popup__popup-buttons__buttons-content'}>
                            <ButtonComponent
                                type={'flat'} bordered={true}
                                text={'Undo'} iconLeft={IconUndoSmBrown}
                                callback={() => setShowDigitalSignaturePopup(false)}
                            />
                            <ButtonComponent
                                type={'flat'} bordered={true}
                                text={'Clear all'} iconLeft={IconClearSmBrown}
                                callback={clearHandler}
                            />
                        </Row>
                    </Col>
                    <Col xs={12} className={'user-signature-popup__popup-editor'}>
                        <Canvas/>
                    </Col>
                    <Col xs={12} className={'user-signature-popup__popup-sign-form-button'}>
                        <ButtonComponent
                            text={'Sign documents'} iconLeft={IconCheckSmBrown}
                            callback={digitalSignatureSubmitHandler}
                        />
                    </Col>
                </DefaultPopupComponent>
                }

                <Col xs={12} className={'user-dashboard-submit-request-step__step-header'}>
                    <span className={'user-dashboard-submit-request-step__step-header__main-header'}>Sign a form</span>
                    <span className={'user-dashboard-submit-request-step__step-header__sub-header'}>Before signing, check that all data is correct:</span>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-container'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Types of refund you choose in the step one</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                {refundOptionsCategoriesList}
                            </Row>
                        </Col>
                    </Row>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-container'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Uploaded documents</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                {uploadedDocumentsList}
                            </Row>
                        </Col>
                    </Row>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-container'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Personal Data</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-content'}>
                            <span>{userFirstName} {userLastName}</span><br/>
                            <span>{userAddressStreet} {userAddressHouseNo}</span><br/>
                            <span>{userAddressPostCode} {userAddressCityOrTown}</span><br/>
                        </Col>
                    </Row>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-container'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Select the signature type</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                <Col xs={6} lg={4} className={`user-dashboard-signature-type-choice ${selectedUserSignatureType === 1 ? 'selected-type' : ''}`} onClick={() => setSelectedUserSignatureType(selectedUserSignatureType === 1 ? 0 : 1)}>
                                    <Row className={'user-dashboard-signature-type-choice__signature-content'}>
                                        <Col xs={4} lg={2} className={'user-dashboard-signature-type-choice__signature-choice-button'}>
                                            <SvgIconComponent iconSource={selectedUserSignatureType === 1 ? IconRadioCheckedSmOrange : IconRadioUnCheckedSmGrey} className={'user-dashboard-signature-type-choice__signature-choice-button__button-icon'} />
                                        </Col>
                                        <Col xs={8} lg={10} className={'user-dashboard-signature-type-choice__signature-type-name'}>
                                            <span>Digital signature</span>
                                        </Col>
                                        {/*<Col xs={12} className={'user-dashboard-signature-type-choice__signature-type-description'}>*/}
                                        {/*    <span>Description</span>*/}
                                        {/*</Col>*/}
                                    </Row>
                                </Col>
                                <Col xs={6} lg={4} className={`user-dashboard-signature-type-choice ${selectedUserSignatureType === 2 ? 'selected-type' : ''}`} onClick={() => setSelectedUserSignatureType(selectedUserSignatureType === 2 ? 0 : 2)}>
                                    <Row className={'user-dashboard-signature-type-choice__signature-content'}>
                                        <Col xs={4} lg={2} className={'user-dashboard-signature-type-choice__signature-choice-button'}>
                                            <SvgIconComponent iconSource={selectedUserSignatureType === 2 ? IconRadioCheckedSmOrange : IconRadioUnCheckedSmGrey} className={'user-dashboard-signature-type-choice__signature-choice-button__button-icon'} />
                                        </Col>
                                        <Col xs={8} lg={10} className={'user-dashboard-signature-type-choice__signature-type-name'}>
                                            <span>Electronic signature</span>
                                        </Col>
                                        {/*<Col xs={12} className={'user-dashboard-signature-type-choice__signature-type-description'}>*/}
                                        {/*    <span>Description</span>*/}
                                        {/*</Col>*/}
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>

                <Col className={'user-dashboard-submit-request-step__step-buttons'}>
                    <Row className={'user-dashboard-submit-request-step__step-buttons__buttons-content'}>
                        <ButtonComponent
                            size={'l'} type={'flat'}
                            text={'Previous'} iconLeft={IconArrowLeftSmBrown}
                            callback={() => userSubmitRequestStepSetter(3)}
                        />
                        <ButtonComponent
                            size={'l'}
                            text={'Sign a form'} iconRight={IconPenSmBrown}
                            callback={() => redirectToDocusignRequestHandler()}
                            buttonDisabled={selectedUserSignatureType === 0}
                        />
                    </Row>
                </Col>

            </Row>
        </Col>
    );

};


export default UserDashboardSubmitRequestStep4Component;
